import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Domain, TargetDomain } from '@shared/models/dataref.model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PackLite } from '@shared/models/generic/pack-lite.model';
import { DomainSelectorComponent } from '@shared/components/domain-selector/domain-selector.component';

type DomainSelected = { value: Domain; selected: boolean };

@Component({
  selector: 'app-pack-target-domains',
  templateUrl: './pack-target-domains.component.html',
  standalone: false,
})
export class PackTargetDomainsComponent implements OnInit, OnChanges {
  @Input()
    pack: PackLite = {} as PackLite;
  @Input()
    referenceType = '';
  @Input()
    targetDomains: TargetDomain[] = [];

  @ViewChild('appDomainSelector') appDomainSelector: DomainSelectorComponent = {} as DomainSelectorComponent;

  form: UntypedFormGroup = this.formBuilder.group({
    targetDomains: this.formBuilder.array([]),
  });

  constructor(protected formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.pack?.currentValue) {
      this.pack = changes.pack.currentValue;
    }
    if (changes.targetDomains) {
      this.buildForm();
    }
  }

  buildForm(): void {
    this.form = this.formBuilder.group({
      targetDomains: this.formBuilder.control(this.targetDomains ?? []),
    });
  }

  isTargetDomainsDisabled(pack: PackLite | null, domain: DomainSelected): boolean {
    if (pack) {
      return pack.domain === 'PRO_COO' || domain.value.key === pack.domain;
    }
    return false;
  }
}
